export interface IMissingFieldOption {
  key: string;
  label: string;
}

// Keys must match the `listingsMissing` dictionary keys returned by /stats/listings
// and the `missingFields` filter expected by /part/listings.
export const MISSING_FIELD_OPTIONS: IMissingFieldOption[] = [
  { key: "MPN", label: "MPN" },
  { key: "OEMPN", label: "OEMPN" },
  { key: "Brand", label: "Brand" },
  { key: "Make", label: "Make" },
  { key: "Model", label: "Model" },
  { key: "VIN", label: "VIN" },
  { key: "Grade", label: "Grade" },
  { key: "KType", label: "KType" },
];
